/**
 * @generated SignedSource<<9f6f5a91fccb133818d091e988b69601>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedCircles_item$data = {
  readonly condensedCircleContent: ReadonlyArray<{
    readonly members: ReadonlyArray<{
      readonly anchor: {
        readonly source: {
          readonly __typename: "Creator";
          readonly browsePageImage: string | null;
          readonly browsePageLinkData: {
            readonly isLinkable: boolean | null;
            readonly path: string | null;
          };
          readonly displayName: string | null;
        } | {
          readonly __typename: "IconicDesign";
          readonly browsePageImage: string | null;
          readonly browsePageLinkData: {
            readonly isLinkable: boolean | null;
            readonly path: string | null;
          };
          readonly displayName: string | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null;
      } | null;
    } | null> | null;
  } | null> | null;
  readonly isArt: boolean | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "PdpRespCondensedCircles_item";
};
export type PdpRespCondensedCircles_item$key = {
  readonly " $data"?: PdpRespCondensedCircles_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedCircles_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "browsePageImage",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "LinkData",
    "kind": "LinkedField",
    "name": "browsePageLinkData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isLinkable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "path",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedCircles_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnchorList",
      "kind": "LinkedField",
      "name": "condensedCircleContent",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AnchorListMember",
          "kind": "LinkedField",
          "name": "members",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Anchor",
              "kind": "LinkedField",
              "name": "anchor",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "source",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v0/*: any*/),
                      "type": "Creator",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v0/*: any*/),
                      "type": "IconicDesign",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "1d74b645535f68318733cb1e82101da5";

export default node;
